import { AspectRatioRounded, Search } from '@mui/icons-material';
import { FilledInput, FormControl, Grid, IconButton, InputAdornment, InputLabel } from '@mui/material';
import useAspectRatio from '../../../../hooks/useAspectRatio';
import { useDispatch, useSelector } from 'react-redux';
import styles from '../SearchBox/styles';
import { useState } from 'react';
import { REDUX_ACTIONS } from '../../../../shared/config/constants';

const RealtimeCollectionsControls = () => {
  const classes = styles();
  const dispatch = useDispatch();
  const { preferences } = useSelector((state) => state.currentUser);
  const [searchText, setSearchText] = useState('');

  const handleAspectRatio = useAspectRatio();

  const handleOnChange = (e) => {
    setSearchText(e.target.value);
  };

  const handleSearch = (value) => {
    dispatch({
      type: REDUX_ACTIONS.REALTIME_COLLECTIONS_SEARCH_FILTER,
      payload: value
    });
  };

  const handleEnter = (e) => {
    if (e.key === 'Enter') {
      handleSearch(searchText);
    }
  };

  return (
        <Grid display='flex' alignItems="center" marginLeft='auto'>
            <FormControl>
                <InputLabel
                    htmlFor="outlined-adornment-search"
                    inputprops={{ classes: { root: classes.searchBar } }}
                >
                    Search
                </InputLabel>
                <FilledInput
                    className={classes.searchBar}
                    id="outlined-adornment-search"
                    type="text"
                    label="Search"
                    value={searchText}
                    onChange={handleOnChange}
                    onKeyDown={handleEnter}
                    endAdornment={
                        <InputAdornment position="end">
                            <IconButton
                                edge="end"
                                onClick={() => handleSearch(searchText)}
                            >
                                <Search />
                            </IconButton>
                        </InputAdornment>
                    }
                />
            </FormControl>
            <IconButton
                edge="end"
                onClick={() => {
                  handleAspectRatio(!preferences.aspectChanged);
                }}
            >
                <AspectRatioRounded />
            </IconButton>
        </Grid>
  );
};

export default RealtimeCollectionsControls;
